import React from 'react';

const Services = ({data}) => {

    return (
            <div className='container'>
                <div className='policy_section_wrapper'>
                    <h1 className=''>{data.title}</h1>

                    {data.list.map((item, i) => {
                        return (
                            <div className="policy_section_item" key={item.title + i}>
                                <h4>{item.title}</h4>
                                {item.list.map((el, i) => {
                                    return (
                                        <p className='main_text_style' key={i}>{el}</p>
                                    )
                                })}
                            </div>
                        )
                    })}
                </div>
            </div>
    );
};

export default Services;